import React from 'react';
import './PolicyPage.css';
import Footer from './Footer';
import ContactHome from './ContactHome';

const Terms = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <h1>Terms of Service</h1>
        <div className="policy-content">
          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using Fractallogy's services, you accept and agree to be bound by the terms 
              and provision of this agreement. If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section>
            <h2>2. Use License</h2>
            <p>
              Permission is granted to temporarily access the materials on Fractallogy's website for personal, 
              non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, 
              and under this license you may not:
            </p>
            <ul>
              <li>Modify or copy the materials</li>
              <li>Use the materials for any commercial purpose or for any public display</li>
              <li>Attempt to reverse engineer any software contained on the website</li>
              <li>Remove any copyright or other proprietary notations from the materials</li>
            </ul>
          </section>

          <section>
            <h2>3. Service Availability</h2>
            <p>
              We strive to ensure our services are available 24/7, but we do not guarantee uninterrupted 
              access. We reserve the right to perform maintenance, updates, or modifications that may temporarily 
              affect service availability.
            </p>
          </section>

          <section>
            <h2>4. User Responsibilities</h2>
            <p>
              You are responsible for maintaining the confidentiality of your account credentials and for all 
              activities that occur under your account. You agree to notify us immediately of any unauthorized 
              use of your account.
            </p>
          </section>

          <section>
            <h2>5. Prohibited Uses</h2>
            <p>
              You may not use our services:
            </p>
            <ul>
              <li>In any way that violates any applicable law or regulation</li>
              <li>To transmit any malicious code or harmful content</li>
              <li>To impersonate or attempt to impersonate the company or any employee</li>
              <li>In any manner that could damage, disable, or impair our services</li>
            </ul>
          </section>

          <section>
            <h2>6. Limitation of Liability</h2>
            <p>
              In no event shall Fractallogy or its suppliers be liable for any damages arising out of the use 
              or inability to use the materials on our website, even if we have been notified of the possibility 
              of such damage.
            </p>
          </section>

          <section>
            <h2>7. Changes to Terms</h2>
            <p>
              We reserve the right to revise these terms at any time without notice. By using our services, 
              you are agreeing to be bound by the then current version of these terms.
            </p>
          </section>

          <section>
            <h2>8. Contact Information</h2>
            <p>
              For questions about these Terms of Service, please{' '}
              <button 
                className="policy-email-link"
                onClick={() => window.dispatchEvent(new CustomEvent('openContactForm'))}
              >
                contact us
              </button>.
            </p>
          </section>
        </div>
      </div>
      <ContactHome />
      <Footer />
    </div>
  );
};

export default Terms;
